import { ISuiteTypesAdditionalSettings } from '@llws/lift-entity-interfaces';
import { QueryStringCommandOptions } from '@/shared';
import { StoreBaseImplementation } from '@/shared/classes/store-base-implementation';

const adminGatewayResourcePath: string = '/web-components-api/suite_types_additional_settings';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: QueryStringCommandOptions = {};
const defaultGetSingleFilters: QueryStringCommandOptions = {};
const base = new StoreBaseImplementation<ISuiteTypesAdditionalSettings>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
